import { get as _get, filter as _filter, uniqBy as _uniqBy } from 'lodash-es';
import React, { FC, useMemo } from 'react';
import { useQuery } from '@apollo/client/react';
import SelectField from './select-field';
import { myGroupsQuery } from '../../apollo/groups';
import { useAppContext } from '../../contexts/app';
import { Group } from '../../types/Group/Group';

type GroupFieldProps = {
  name: string;
  permission: 'createEvent' | 'createPost' | 'uploadImage';
  group?: Group;
  [key: string]: unknown;
};

const GroupField: FC<GroupFieldProps> = ({ name, permission, group, ...rest}) => {
  const { isLoggedIn } = useAppContext();

  const { data: groupsData } = useQuery(myGroupsQuery, {
    skip: !isLoggedIn,
  });

  const groups = useMemo(() => {
    if (!groupsData) {
      return [];
    }
    return _filter(_get(groupsData, 'me.groups', []), `permissions.${permission}`);
  }, [groupsData, permission]);

  const options = useMemo(() => {
    const array = group ? [{ value: group.id, label: group.name }] : [];
    if (!groups) {
      return array;
    }
    return _uniqBy([
      ...array,
      ...groups.map((g) => ({
        value: g.id,
        label: g.name,
      })),
    ], 'value');
  }, [groups, group]);

  return (
    <SelectField
      name={name}
      {...rest}
      options={options}
    />
  );
};

export default GroupField;
